export default class StripeSessionModel {
  constructor (json) {
    this.id = json.sessionId || null
    this.regularPrice = json.regularPrice || 0
    this.percentOff = json.percentOff || 0
    this.finalPrice = json.finalPrice || 0
    this.currency = json.currency || ''
  }
}
